import { environment } from 'src/environments/environment';

export const BASE_URL = environment.baseUrl;
